import { render, staticRenderFns } from "./ListAffiliate.vue?vue&type=template&id=68668662&scoped=true&"
import script from "./ListAffiliate.vue?vue&type=script&lang=js&"
export * from "./ListAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./ListAffiliate.vue?vue&type=style&index=0&id=68668662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68668662",
  null
  
)

export default component.exports